import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { MagellanLogoColored } from 'library';
import { logout } from 'utils/authService';
import { RELEASE_NOTES_URL } from 'utils/constants';
import packageJson from '../../../package.json';

const Footer = () => (
  <>
    <Box display="flex">
      <Button
        className="heap-button"
        href={RELEASE_NOTES_URL}
        sx={{
          mb: 3,
          mt: 'auto',
          mx: 'auto',
          padding: '2px 0',
          width: 56,
        }}
        target="_blank"
        variant="text"
      >
        Release Notes
      </Button>
      <Button
        className="heap-button"
        onClick={logout}
        sx={{
          mb: 3,
          mt: 'auto',
          mx: 'auto',
          padding: '2px 0',
          width: 56,
        }}
        variant="text"
      >
        Log Out
      </Button>
    </Box>
    <MagellanLogoColored
      sx={{
        maxHeight: 32,
        mb: 3,
        mt: 'auto',
        mx: 'auto',
        padding: '0 52px',
        width: '100%',
      }}
    />
    <Typography align="center" sx={{ mb: 3 }} variant="caption">
      Version {packageJson.version}
    </Typography>
  </>
);

export default Footer;
